import React, { useContext } from 'react';

const CartWizardStepContext = React.createContext();

// eslint-disable-next-line import/prefer-default-export
export const useWizardStep = () => useContext(CartWizardStepContext);
export default CartWizardStepContext;
